import React from "react";
import { ModalUnderConstruction } from "components";

export const AboutSubModal: React.FunctionComponent = () => {
  return <ModalUnderConstruction subtext="The about page is coming soon..." />;
};
